import { createFileRoute } from '@tanstack/react-router';

import { ProfileScreen } from '../../features/account/profile-screen';

/** S22 프로필 — 계정 목차의 첫 화면 (D146 ⑥). */
export const Route = createFileRoute('/account/profile')({
  component: ProfileScreen,
});
